<template>
  <div>

    <!-- PAQUETE PRINCIPAL -->
  
    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="HexagonIcon" class="mr-2 icon" />PAQUETE PRINCIPAL</span>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                    
          <v-select class="w-full mr-2" 
            v-model="tipoProducto" 
            :options="comboTipoProductosFiltrados" 
            label="tipoProducto"
            placeholder="Selecciona un tipo de producto"
            @input="changeTipoProducto(tipoProducto)"    
            :reduce="id => id.tipoProducto"
            :disabled="disabledProductoPrincipal">
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                
          <v-select class="w-full mr-2" 
            v-model="productoPrincipal" 
            :options="comboProductosFiltrados"            
            :getOptionLabel="productoPrincipal => productoPrincipal.producto"
            placeholder="Selecciona un producto"
            @input="changeProducto"
            :disabled="disabledProductoPrincipal">
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addProducto(productoPrincipal)" :disabled="disabledProductoPrincipal">Añadir</vs-button>            
        </vs-col>        
      </vs-row>
      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosPrincipal" :key="'PRODUCTO_PRINCIPAL_'+index">
        <vs-row v-if="item.seccion==='PRODUCTO_PRINCIPAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
            <vs-button size="small" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteProducto(item)">Eliminar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>        
    </vx-card>

    <!-- FIN PAQUETE PRINCIPAL -->

    <!-- PRIMER MOVIL ADICIONAL -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />PRIMER MOVIL ADICIONAL</span>
        </vs-col>
      </vs-row>
      <vs-row v-if="habilitoComboPrimerMovilAdicional">
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                    
          <v-select class="w-full mr-2" 
            v-model="primerMovilAdicional" 
            :options="comboPrimerMovilAdicionalFiltrado"               
            :getOptionLabel="primerMovilAdicional => primerMovilAdicional.producto"
            placeholder="Selecciona primer movil adicional"
            :disabled="disabledPrimerMovilAdicional">             
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-w="5"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addProducto(primerMovilAdicional)" :disabled="disabledPrimerMovilAdicional">Añadir</vs-button>            
        </vs-col>
      </vs-row>      

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosPrimerMovilAdicional" :key="'PRIMER_MOVIL_ADICIONAL_'+index">
        <vs-row v-if="item.seccion==='PRIMER_MOVIL_ADICIONAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
            <vs-button size="small" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteProducto(item)">Eliminar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>
          
    <!-- FIN PRIMER MOVIL ADICIONAL -->

    <!-- MOVIL ADICIONAL -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="SmartphoneIcon" class="mr-2 icon" />MOVIL ADICIONAL</span>
        </vs-col>
      </vs-row>
      <vs-row v-if="habilitoComboMovilAdicional">
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                    
          <v-select class="w-full mr-2" 
            v-model="movilAdicional" 
            :options="comboMovilAdicionalFiltrado"               
            :getOptionLabel="movilAdicional => movilAdicional.producto"
            placeholder="Selecciona movil adicional"
            :disabled="disabledMovilAdicional">             
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-w="5"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addProducto(movilAdicional)" :disabled="disabledMovilAdicional">Añadir</vs-button>            
        </vs-col>
      </vs-row>   

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosMovilAdicional" :key="'MOVIL_ADICIONAL_'+index">
        <vs-row v-if="item.seccion==='MOVIL_ADICIONAL'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
            <vs-button size="small" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteProducto(item)">Eliminar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>
    
    <!-- FIN MOVIL ADICIONAL -->

    <!-- TV -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="TvIcon" class="mr-2 icon" />TV</span>
        </vs-col>
      </vs-row>
      <vs-row v-if="habilitoComboTv">
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                    
          <v-select class="w-full mr-2"
            v-model="tv" 
            :options="comboTvFiltrado"               
            :getOptionLabel="tv => tv.producto"
            placeholder="Selecciona TV"
            :disabled="disabledTv">             
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-w="5"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addProducto(tv)" :disabled="disabledTv">Añadir</vs-button>            
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosTv" :key="'TV_'+index">
        <vs-row v-if="item.seccion==='TV'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
            <vs-button size="small" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteProducto(item)">Eliminar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>

    <!-- FIN TV -->

    <!-- SVA -->

    <vx-card card-border class="mb-6">
      <vs-row>
        <vs-col class="mb-4" vs-type="flex" vs-align="center" vs-w="12">
          <span class="textoOperacionComentarioDateTime"><feather-icon icon="WifiIcon" class="mr-2 icon" />SVA</span>
        </vs-col>
      </vs-row>
      <vs-row v-if="habilitoComboSva">
        <vs-col vs-type="flex" vs-align="center" vs-w="5">                    
          <v-select class="w-full mr-2" 
            v-model="sva" 
            :options="comboSvaFiltrado"               
            :getOptionLabel="sva => sva.producto"
            placeholder="Selecciona Sva">             
            <span slot="no-options">
              No hay datos
            </span>
          </v-select>
        </vs-col>
        <vs-col vs-w="5"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <vs-button icon-pack="feather" icon="icon-plus" @click="addProducto(sva)" :disabled="disabledSva">Añadir</vs-button>            
        </vs-col>
      </vs-row>

      <vx-card class="w-full mb-2 mt-2" card-border v-for="(item, index) in filtroProductosContratadosSva" :key="'VALOR_AÑADIDO_'+index">
        <vs-row v-if="item.seccion==='VALOR_AÑADIDO'">
          <vs-col vs-type="flex" vs-align="center" vs-w="9">
            <span class="textoOperacionComentarioProducto">{{ item.producto }} ({{item.caracteristicas}})</span>    
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="1">
            <span class="textoOperacionComentarioProducto">{{item.importeConPromocion}}€</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
            <vs-button size="small" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteProducto(item)">Eliminar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>

    <!-- FIN SVA -->

    <!-- SUMA TOTAL -->

    <vx-card slot="no-body" class="w-full mb-20 mt-16 fondoComentario" card-border>
      <vs-row>
        <vs-col vs-w="2"></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <span class="textoImporteTotalOperacionProducto">IMPORTE TOTAL: </span>    
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="flex-end" vs-w="2">
          <span class="textoImporteTotalOperacionProducto">{{sumaImporteTotal}}€</span>
        </vs-col>
        <vs-col vs-w="2"></vs-col>
      </vs-row>
    </vx-card> 

    <!-- FIN SUMA TOTAL -->

  </div>
</template>

<script>
import commonComponentsStore from '@/store/common-components/index.js'
import productosStore from '@/store/gestion/productos/index.js'
import operacionesStore from '@/store/gestion/operaciones/index.js'
import vSelect from 'vue-select'

export default {
  name: 'operacionesEditProductos',
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      seccionPrincipal: 'PRODUCTO_PRINCIPAL',
      seccionPrimerMovilAdicional: 'PRIMER_MOVIL_ADICIONAL',
      seccionMovilAdicional: 'MOVIL_ADICIONAL',
      seccionSva: 'VALOR_AÑADIDO',
      seccionTv: 'TV',
      cliente: {},      
      productosContratados: [],
      codigoPrincipal: null,      
      productos: [], // productos del paquete_principal
      tipoProducto: null, // objeto para hacer la busqueda de los combos del paquete_principal            
      productoPrincipal: null, // objeto del producto_principal
      valProductos: [],
      primerMovilAdicional: {}, // objeto para hacer la busqueda de los combos del primer_movil_adicional
      sva: {},
      tv:{},
      movilAdicional: {},    
      disabledProductoPrincipal: false,
      disabledPrimerMovilAdicional: false,
      disabledMovilAdicional: false,
      disabledSva: false,
      disabledTv: false,
      habilitoComboPrimerMovilAdicional: false,
      habilitoComboMovilAdicional: false,
      habilitoComboSva: false,
      habilitoComboTv: false,
      borrado: false
    }
  },
  computed: {
    comboTipoProductosFiltrados () {
      const filtrado = []
      
      const filtered = this.valProductos.filter(el => el.seccion === this.seccionPrincipal)

      filtered.forEach(function (item) {
        const i = filtrado.findIndex(x => x.tipoProducto === item.tipoProducto)
        if (i <= -1) {          
          filtrado.push(item)
        }
      })       
      return filtrado
    },    
    comboProductosFiltrados () {
      const filtrado = []
      this.productos.forEach(function (item) {
        const i = filtrado.findIndex(x => x.producto === item.producto)
        if (i <= -1) {
          filtrado.push(item)
        }
      })
      filtrado.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })      
      return filtrado      
    },    
    comboPrimerMovilAdicionalFiltrado () {  
      // filtramos por los elementos que tengan el atributo asociados
      const listaPrimerMovilAdicional = this.valProductos.filter(el => el.seccion === this.seccionPrimerMovilAdicional)

      const filtrado = listaPrimerMovilAdicional.filter(function (el) {                
        return el.hasOwnProperty('asociados')
      })      

      // buscamos si el codigoPrincipal esta dentro del campo asociados      
      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      
      return result                     
    },
    comboMovilAdicionalFiltrado () {
      const listaMovilAdicional = this.valProductos.filter(el => el.seccion === this.seccionMovilAdicional)

      const filtrado = listaMovilAdicional.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      return result
    },
    comboSvaFiltrado () {    
      const listaSva = this.valProductos.filter(el => el.seccion === this.seccionSva)

      const filtrado = listaSva.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }       
      }
      listaSva.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })

      return listaSva
    },
    comboTvFiltrado () {
      const listaTv = this.valProductos.filter(el => el.seccion === this.seccionTv)

      const filtrado = listaTv.filter(function (el) {        
        return el.hasOwnProperty('asociados')
      })

      const result = []
      let asociados = []
      for (let i = 0; i < filtrado.length; i++) {
        asociados = filtrado[i].asociados.split('_')
        if (asociados.find(el => parseInt(el) === this.codigoPrincipal)) {
          result.push(filtrado[i])
        }        
      }

      result.sort((a, b) => { // mostrar ordenados por campo orden
        return a.orden - b.orden
      })
      return result
    },
    codigoPrincipalFiltrado () { // tenemos que pillar el codigoPrincipal del PRODUCTO_PRINCIPAL
      let filtrado = this.productosContratados.filter(function (el) {        
        if (el.seccion === 'PRODUCTO_PRINCIPAL') {
          return el
        }
      })
      filtrado = filtrado[0].codigoPrincipal // devuelve un array con un elemento
      return filtrado
    },
    filtroProductosContratadosPrincipal () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'PRODUCTO_PRINCIPAL'        
      })      
      return filtrado
    },
    filtroProductosContratadosPrimerMovilAdicional () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'PRIMER_MOVIL_ADICIONAL'        
      })
      return filtrado
    },
    filtroProductosContratadosMovilAdicional () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'MOVIL_ADICIONAL'        
      })      
      return filtrado
    },
    filtroProductosContratadosSva () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'VALOR_AÑADIDO'        
      })
      return filtrado
    },
    filtroProductosContratadosTv () {
      const filtrado = this.productosContratados.filter(function (el) {        
        return el.seccion === 'TV'        
      })
      return filtrado
    },
    sumaImporteTotal () {
      const filtrado = this.productosContratados.reduce((prev, cur) => {
        return prev + cur.importeConPromocion
      }, 0)
      return filtrado
    }
  },
  methods: {
    /* creo 2 funciones diferentes porque en el created no tengo el mismo objeto que despues*/
    esProductoUnico (tipoProducto) {
      let uni = null
      tipoProducto.unico === 'S' ? uni = true : uni = false      
      return uni
    },
    esProductoUnicoCreated (tipoProducto) {       
      let uni = null
      tipoProducto[0].productoTarjetas[0].unico === 'S' ? uni = true : uni = false      
      return uni
    },
    async createObjectProducto (produc) {
      const prod              = {}
      const arrProductoTarjetas  = []
      
      prod.operacion            = `/api/operacions/${this.operacion.id}`
      prod.tipoTarjeta          = produc.tipoTarjeta
      prod.tipoProducto         = produc.tipoProducto
      prod.seccion              = produc.seccion
      prod.producto             = produc.producto
      prod.promocion            = produc.promocion
      prod.importeSinPromocion  = produc.importeSinPromocion
      prod.importeConPromocion  = produc.importeConPromocion
      prod.caracteristicas      = produc.caracteristicas
      prod.codigoPrincipal      = produc.codigoPrincipal
      
      const datos = ['FIJO', 'MOVIL', 'TV']
      let completado = ''

      switch (produc.tipoTarjeta) {      
      case 'COMBO': 
      // caso COMBO_TV/SVA/TV completo = true
        for (let i = 0; i < 2; i++) {          
          const productoDetalle   = 
            {
              persona: `/api/personas/${this.cliente.persona.id}`,
              fechaInstalacion: null,
              fechaPortabilidad: null,
              estado: null,
              altaPortabilidad: 'portabilidad',
              telefonoPortabilidad: null,
              operadorDonante: null,
              titularIgualCliente: 'S',
              comentarios: null,
              terminal: 'N',
              modeloTerminal: null,
              prepago: 'N',
              iccc: null,
              tarjeta: datos[i],
              unico: produc.unico,
              completo: false
            }          
          arrProductoTarjetas.push(productoDetalle)                  
        }
        break
      case 'COMBO_TV':        
        for (let i = 0; i < 3; i++) {
          i === 2 ? completado = true : completado = false
          const productoDetalle   = 
            {
              persona: `/api/personas/${this.cliente.persona.id}`,
              fechaInstalacion: null,
              fechaPortabilidad: null,
              estado: null,
              altaPortabilidad: 'portabilidad',
              telefonoPortabilidad: null,
              operadorDonante: null,
              titularIgualCliente: 'S',
              comentarios: null,
              terminal: 'N',
              modeloTerminal: null,
              prepago: 'N',
              iccc: null,
              tarjeta: datos[i],
              unico: produc.unico,
              completo: completado
            }          
          arrProductoTarjetas.push(productoDetalle)                  
        }
        break
      // eslint-disable-next-line no-case-declarations
      default:
        const productoDetalle  = 
          {
            persona: `/api/personas/${this.cliente.persona.id}`,
            fechaInstalacion: null,
            fechaPortabilidad: null,
            estado: null,
            altaPortabilidad: 'portabilidad',
            telefonoPortabilidad: null,
            operadorDonante: null,
            titularIgualCliente: 'S',
            comentarios: null,
            terminal: 'N',
            modeloTerminal: null,
            prepago: 'N',
            iccc: null,
            tarjeta: produc.tipoTarjeta,
            unico: produc.unico,
            completo: completado
          }      
        produc.tipoTarjeta === 'SVA' || produc.tipoTarjeta === 'TV' ? productoDetalle.completo = true : productoDetalle.completo = false        
        arrProductoTarjetas.push(productoDetalle)
        break
      }
      
      prod.productoTarjetas = arrProductoTarjetas

      this.$vs.loading('material')
      
      await this.$store.dispatch('productosStore/addProducto', prod)
        .then(          
          this.showUpdateSuccess('PRODUCTO CONTRATADO', 'Se ha contratado el producto seleccionado')
        )
        .catch((error) => { 
          this.showUpdateError(error)
          console.error(error) 
        })
      
      this.$vs.loading.close()

      /**
       * Cando añadimos un producto debemos lanzar a función que actualiza a porcentaxe completada da operación
       */
      await this.$store.dispatch('operacionesStore/actualizarPorcentajeCompletado', this.operacion.id)
        .then()
        .catch((error) => {
          console.error(error)         
        })

      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then(() => {          
          this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))
          this.codigoPrincipal      = this.$store.state.operacionesStore.operacion.productos[0].codigoPrincipal
          // Actualizamos a operación no Store e lanzamos o emit para que se actualice a barra de progreso de porcentaxe completado da operación      
          this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
          this.$emit('actualizar-barra-porcentaje-completado')  
          //return true
        })
        .catch((error) => {          
          console.error(error)         
        })
    },
    async deleteObjectProducto (producto) {
      await this.$store.dispatch('productosStore/deleteProducto', producto.id)
        .then(                              
          this.showUpdateSuccess('PRODUCTO ELIMINADO', 'El producto ha sido eliminado')          
        )
        .catch((error) => {           
          this.showUpdateError(error)
          console.error(error) 
        })
      this.$vs.loading.close()
      
      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then(() => {          
          this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))
          this.codigoPrincipal      = this.$store.state.operacionesStore.operacion.productos[0].codigoPrincipal            
        })
        .catch((error) => {            
          console.error(error)         
        })
    },
    async addProducto (producto) {      

      await this.createObjectProducto(producto)
      
      switch (producto.seccion) {
      case 'PRODUCTO_PRINCIPAL':
        this.primerMovilAdicional = this.movilAdicional = this.tv = this.sva = null
        this.disabledProductoPrincipal = this.habilitoComboPrimerMovilAdicional  = this.habilitoComboSva = this.habilitoComboTv = true
        break
      case 'PRIMER_MOVIL_ADICIONAL':
        this.habilitoComboMovilAdicional = true
        this.esProductoUnico(this.primerMovilAdicional) ? this.disabledPrimerMovilAdicional = true : this.disabledPrimerMovilAdicional = false        
        break
      case 'MOVIL_ADICIONAL':
        this.esProductoUnico(this.movilAdicional) ? this.disabledMovilAdicional = true : this.disabledMovilAdicional = false        
        break
      case 'SVA':
        this.esProductoUnico(this.sva) ? this.disabledSva = true : this.disabledSva = false        
        break
      case 'TV':
        this.esProductoUnico(this.tv) ? this.disabledTv = true : this.disabledTv = false
        break      
      }
    },    
    async deleteProducto (producto) {      
      this.$vs.loading('material')
      switch (producto.seccion) {
      case 'PRODUCTO_PRINCIPAL': //borrar todos
        
        for (let i = 0; i < this.productosContratados.length; i++) {          
          await this.$store.dispatch('productosStore/deleteProducto', this.productosContratados[i].id)
            .then(          
              this.borrado = true
            )
            .catch((error) => { 
              this.borrado = false                            
              console.error(error) 
            })                    
        }
                
        this.borrado === true ? this.showUpdateSuccess('PRODUCTO ELIMINADO', 'El producto ha sido eliminado') : this.showUpdateError('Se ha producido un erro')
        
        this.codigoPrincipal                    = this.tipoProducto = this.productoPrincipal = null
        this.productosContratados               = []  // se inicia desde el store en el created si cambiamos de pantalla        
        this.primerMovilAdicional               = true
        this.habilitoComboMovilAdicional        = false
        this.habilitoComboSva                   = this.habilitoComboTv = false                                                  
        this.movilAdicional                     = this.sva = this.tv = null                                                                              
        this.disabledProductoPrincipal          = this.disabledPrimerMovilAdicional = this.habilitoComboPrimerMovilAdicional = false        

        await this.$store.dispatch('operacionesStore/updateOperacionProductos', this.productosContratados)
          .then(() => {          
            this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))            
            //return true
          })
          .catch((error) => {   
            console.error(error)         
          })

        /**
         * Cando eliminamos o producto principal debemos lanzar a función que actualiza a porcentaxe completada da operación
         */
        await this.$store.dispatch('operacionesStore/actualizarPorcentajeCompletado', this.operacion.id)
          .then()
          .catch((error) => {
            console.error(error)         
          })

        await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
          .then(() => {          
            this.productosContratados = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos)) 
            // Actualizamos a operación no Store e lanzamos o emit para que se actualice a barra de progreso de porcentaxe completado da operación      
            this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
            this.$emit('actualizar-barra-porcentaje-completado')       
          })
          .catch((error) => {            
            console.error(error)         
          })

        break
      case 'PRIMER_MOVIL_ADICIONAL':        
        this.deleteObjectProducto(producto)
        this.movilAdicional = this.filtroProductosContratadosMovilAdicional        
        if (this.movilAdicional.length > 0) {          
          for (let i = 0; i < this.movilAdicional.length; i++) {
            this.deleteObjectProducto(this.movilAdicional[i])
          }
        }
        this.disabledPrimerMovilAdicional = false
        this.primerMovilAdicional = this.movilAdicional = null
        this.habilitoComboMovilAdicional = false                
        break
      default:  
      
      //TODO crear funcion para borrar un objeto y controlar si se borra el promerMovilAdicional para borrar el movilAdicional
        this.deleteObjectProducto(producto)

        if (producto.seccion === this.seccionMovilAdicional) {        
          this.disabledMovilAdicional = false
          this.movilAdicional = null
        } else if (producto.seccion === this.seccionTv) {
          this.disabledTv = false
          this.tv = null
        }
        break
      }
    },
    changeTipoProducto (tipoProducto) {
      this.productoPrincipal = null
      this.productos = this.valProductos.filter(function (el) { return el.tipoProducto === tipoProducto })
    },
    changeProducto () {
      this.productos = this.comboProductosFiltrados
    },
    showUpdateSuccess (titulo, texto) {
      this.$vs.loading.close()
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError (texto) {
      this.$vs.loading.close()
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: texto
      })
    }
  },
  async created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }    

    if (!productosStore.isRegistered) {
      this.$store.registerModule('productosStore', productosStore)
      productosStore.isRegistered = true
    }              

    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))     
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))  
    
    const busqueda = {}
    busqueda.operador    = this.$store.state.operacionesStore.operacion.operador
    busqueda.tipoCliente = this.$store.state.operacionesStore.operacion.tipoCliente

    await this.$store.dispatch('commonComponentsStore/getValProductosByOperadorCliente', busqueda)
      .then(() => {
        this.valProductos   = JSON.parse(JSON.stringify(this.$store.state.commonComponentsStore.valProductos))
      })

    if (this.operacion.productos.length > 0) {
      
      this.disabledProductoPrincipal  = true
      this.habilitoComboSva           = true
      this.habilitoComboTv            = true
      this.productosContratados       = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.productos))
      this.codigoPrincipal            = this.codigoPrincipalFiltrado
      
      this.primerMovilAdicional = this.movilAdicional = this.sva = this.tv = null
      this.tipoProducto         = this.productoPrincipal = this.filtroProductosContratadosPrincipal      
      this.primerMovilAdicional = this.filtroProductosContratadosPrimerMovilAdicional
      this.movilAdicional       = this.filtroProductosContratadosMovilAdicional
      this.tv                   = this.filtroProductosContratadosTv
      
      this.productoPrincipal.length > 0 ? this.habilitoComboPrimerMovilAdicional = true : this.habilitoComboPrimerMovilAdicional = false    
      this.primerMovilAdicional.length > 0 ? this.habilitoComboMovilAdicional = true : this.habilitoComboMovilAdicional = false

      if (this.primerMovilAdicional.length > 0) {
        this.esProductoUnicoCreated(this.primerMovilAdicional) ? this.disabledPrimerMovilAdicional = true : this.disabledPrimerMovilAdicional = false
      }

      if (this.movilAdicional.length > 0) {        
        this.esProductoUnicoCreated(this.movilAdicional) ? this.disabledMovilAdicional = true : this.disabledMovilAdicional = false
        this.movilAdicional = null
      } else {
        this.disabledMovilAdicional = false
      }

      if (this.tv.length > 0) {
        this.esProductoUnicoCreated(this.tv) ? this.disabledTv = true : this.disabledTv = false
      }
    }
                  
  },
  mounted () {
    this.isMounted = true        
  }
}
</script>
